var exports = {
  "a": "Box__ARqV_G",
};

module.exports = exports;
